export default {
    componentUpdated: el => {
        const tables = el.getElementsByTagName('table');
        const tableTd = el.getElementsByTagName('td');

        if([...tables].length>0){
            [...tables].forEach((el,idx) => {
                el.removeAttribute('width');
                el.removeAttribute('height');
                el.style.width = null;
                el.style.height = null;
            });
        }

        if([...tableTd].length>0){
            [...tableTd].forEach((el,idx) => {
                el.style.width = null;
                el.style.height = null;
            });
        }
    },
    inserted: el => {
        const tables = el.getElementsByTagName('table');
        const tableTd = el.getElementsByTagName('td');

        if([...tables].length>0){
            [...tables].forEach((el,idx) => {
                el.removeAttribute('width');
                el.removeAttribute('height');
                el.style.width = null;
                el.style.height = null;
            });
        }

        if([...tableTd].length>0){
            [...tableTd].forEach((el,idx) => {
                el.style.width = null;
                el.style.height = null;
            });
        }
    }
};